import {SimpleEventResource} from './simpleEventResource.model';
import {SimplePaginationResource} from './simplePaginationResource.model';

export class SimpleQueryResponseResource {
    pagination: SimplePaginationResource;
    events: SimpleEventResource[];
    sortableProperties: string[];

    constructor(map: SimpleQueryResponseResource = {} as SimpleQueryResponseResource) {
        this.pagination = map.pagination || null;
        this.events = map.events || null;
        this.sortableProperties = map.sortableProperties || null;
    }
}
